"use strict"

import ReactNative from "react-native"

var ActivityIndicator = ReactNative.ActivityIndicator

export default ActivityIndicator
